import { useMemo, useState } from "react";
import { pathLangFrom } from "../utils/lang"; // ✅ για να κάνουμε canon (el/en/gr -> el/en)

export default function useFeatureGate({ isLoggedIn, isPremium, lang, navigate }) {
    const [open, setOpen] = useState(false);
    const [config, setConfig] = useState({
        require: "auth",
        title: "",
        message: "",
    });

    const canonLang = pathLangFrom(lang || "el");     // π.χ. gr -> el
    const base = `/${canonLang}`;                    // ✅ αυτό ταιριάζει με το App.js

    const isEL = canonLang === "el" || canonLang === "gr";

    const actions = useMemo(() => {
        return {
            close: () => setOpen(false),

            openAuth: (opts = {}) => {
                setConfig({
                    require: "auth",
                    title: opts.title || (isEL ? "Απαιτείται λογαριασμός" : "Account required"),
                    message:
                        opts.message ||
                        (isEL
                            ? "Για να χρησιμοποιήσεις αυτή τη λειτουργία χρειάζεται να συνδεθείς ή να κάνεις εγγραφή."
                            : "To use this feature, please log in or create an account."),
                });
                setOpen(true);
            },

            openPremium: (opts = {}) => {
                setConfig({
                    require: "premium",
                    title: opts.title || (isEL ? "Premium λειτουργία" : "Premium feature"),
                    message:
                        opts.message ||
                        (isEL
                            ? "Η λειτουργία αυτή είναι διαθέσιμη μόνο για Premium χρήστες."
                            : "This feature is available only for Premium users."),
                });
                setOpen(true);
            },

            guardAuth: (opts = {}) => {
                if (!isLoggedIn) {
                    actions.openAuth(opts);
                    return false;
                }
                return true;
            },

            guardPremium: (opts = {}) => {
                if (!isLoggedIn) {
                    actions.openAuth(opts);
                    return false;
                }
                if (!isPremium) {
                    actions.openPremium(opts);
                    return false;
                }
                return true;
            },

            onLogin: () => {
                setOpen(false);
                navigate(`${base}/login`);      // ✅ σωστό route
            },

            onRegister: () => {
                setOpen(false);
                navigate(`${base}/register`);   // ✅ σωστό route
            },

            onUpgrade: () => {
                setOpen(false);
                navigate(`${base}/plans`);      // ✅ PlansPage
            },
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn, isPremium, canonLang, navigate]);

    return { gateOpen: open, gateConfig: config, gateActions: actions };
}
